<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="fl-right export-btn-first">
        <button
          type="button"
          pButton
          class="ui-button-primary excel-export btn-excel-first"
          (click)="downloadM2PaymentEngagements()">
          <span
            >Download CSV
            @if (isSpin) {
              <i class="fa fa-spinner fa-spin"></i>
            }
          </span>
        </button>
      </div>
    </div>
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }

      <div class="inventory card">
        <p-table
          #dt
          [columns]="pscols"
          [value]="paymentBatchList"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="500px"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="both">
          <ng-template #header let-columns>
            <tr class="border-bottom">
              <th [pSortableColumn]="'partnerID'" class="colsmall">
                Partner ID<p-sortIcon [field]="'partnerID'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'engagementID'" class="colxsmall">
                Engagement ID<p-sortIcon [field]="'engagementID'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'paymentLineItemId'" class="collarge">
                Line Item ID
                <p-sortIcon [field]="'paymentLineItemId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'partnerName'" class="colmedium">
                Partner Name
                <p-sortIcon [field]="'partnerName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'vendorID'" class="colxsmall">
                Vendor ID<p-sortIcon [field]="'vendorID'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'tenantID'" class="colmedium">
                Tenant ID<p-sortIcon [field]="'tenantID'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'tenantName'" class="colsmall">
                Tenant Name<p-sortIcon [field]="'tenantName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'customerID'" class="colsmall">
                Customer ID<p-sortIcon [field]="'customerID'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'customerName'" class="colsmall">
                Customer Name<p-sortIcon [field]="'customerName'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'engagementName'" class="colmedium">
                Workshop Name
                <p-sortIcon [field]="'engagementName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'status'" class="colsmall">
                Workshop Status
                <p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'workshopDetailStatus'" class="colmedium">
                Workshop Detailed Status<p-sortIcon
                  [field]="'workshopDetailStatus'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'completionDate'" class="colsmall">
                Completion Date<p-sortIcon
                  [field]="'completionDate'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'poeStatus'" class="colxsmall">
                POE Status<p-sortIcon [field]="'poeStatus'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'poecompletionDate'" class="colsmall">
                POE Completion Date<p-sortIcon
                  [field]="'poecompletionDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'l1InternalStatusName'" class="colsmall">
                L1InternalStatusName<p-sortIcon
                  [field]="'l1InternalStatusName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'m2PaymentBatchStatus'" class="colmedium">
                M2 Payment Batch Status<p-sortIcon
                  [field]="'m2PaymentBatchStatus'"></p-sortIcon>
              </th>

              <th [pSortableColumn]="'m2PaidDate'" class="colxsmall">
                M2 Paid Date<p-sortIcon [field]="'m2PaidDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'mS2PaymentDesignation'" class="colmedium">
                MS2 Payment Designation<p-sortIcon
                  [field]="'mS2PaymentDesignation'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'m2PaymentAmount'" class="colmedium">
                Milestone Two Payment<br /><span> </span> Amount<p-sortIcon
                  [field]="'m2PaymentAmount'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'area'" class="colxsmall">
                Area<p-sortIcon [field]="'area'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'subsidiary'" class="colxsmall">
                Subsidiary
                <p-sortIcon [field]="'subsidiary'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'m2PaidDate'" class="colxsmall">
                MS Invoice <br /><span> </span> Date
                <p-sortIcon [field]="'m2PaidDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'msInvoiceNo'" class="colsmall">
                MS Invoice Number<p-sortIcon
                  [field]="'msInvoiceNo'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'paymentCentralTransactionID'"
                class="colmedium">
                Payment Central <br />
                Transaction ID<p-sortIcon
                  [field]="'paymentCentralTransactionID'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'requestDate'" class="colxsmall">
                Request Date<p-sortIcon [field]="'requestDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'fiscalYear'" class="colxsmall">
                Fiscal year <p-sortIcon [field]="'fiscalYear'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'cumulativeAmount'" class="colmedium">
                Total Payment Amount<p-sortIcon
                  [field]="'cumulativeAmount'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'earnedDate'" class="colmedium">
                Earned Date<p-sortIcon [field]="'earnedDate'"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              <td class="colsmall">{{ rowData.partnerID }}</td>
              <td class="colxsmall">{{ rowData.engagementID }}</td>
              <td class="collarge">{{ rowData.paymentLineItemId }}</td>
              <td class="colmedium">{{ rowData.partnerName }}</td>
              <td class="colxsmall">{{ rowData.vendorID }}</td>
              <td class="colmedium">{{ rowData.tenantID }}</td>

              <td class="colsmall">{{ rowData.tenantName }}</td>
              <td class="colsmall">{{ rowData.customerID }}</td>
              <td class="colsmall">{{ rowData.customerName }}</td>

              <td class="colmedium">{{ rowData.engagementName }}</td>

              <td class="colsmall">{{ rowData.status }}</td>
              <td class="colmedium">{{ rowData.workshopDetailStatus }}</td>
              <td class="colsmall">
                {{ rowData.completionDate | date: 'yyyy-MM-dd' }}
              </td>
              <td class="colxsmall">{{ rowData.poeStatus }}</td>
              <td class="colsmall">
                {{ rowData.poecompletionDate | date: 'yyyy-MM-dd' }}
              </td>

              <td class="colsmall">{{ rowData.l1InternalStatusName }}</td>
              <td class="colmedium">{{ rowData.m2PaymentBatchStatus }}</td>
              <td class="colxsmall">
                {{ rowData.m2PaidDate | date: 'yyyy-MM-dd' }}
              </td>

              <td class="colmedium">{{ rowData.mS2PaymentDesignation }}</td>
              <td class="colmedium">{{ rowData.m2PaymentAmount }}</td>
              <td class="colxsmall">{{ rowData.area }}</td>
              <td class="colxsmall">{{ rowData.subsidiary }}</td>
              <td class="colxsmall">
                {{ rowData.m2PaidDate | date: 'yyyy-MM-dd' }}
              </td>

              <td class="colsmall">{{ rowData.msInvoiceNo }}</td>
              <td class="colmedium">
                {{ rowData.paymentCentralTransactionID }}
              </td>
              <td class="colxsmall">
                {{ rowData.requestDate | date: 'yyyy-MM-dd' }}
              </td>
              <td class="colxsmall">{{ rowData.fiscalYear }}</td>
              <td class="colmedium">{{ rowData.cumulativeAmount }}</td>
              <td class="colmedium">
                {{ rowData.earnedDate | date: 'yyyy-MM-dd' }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
